<template>
	<strong class="font-medium text-zinc-950 dark:text-white">
		<slot />
	</strong>
</template>

<script lang="ts">
	export default { name: 'VStrong' } // name the component
</script>